import { ChangeDetectorRef, ContentChild, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  ViewEncapsulation
} from '@angular/core';
import { DragTrackerService } from '@services/helpers/drag-tracker/drag-tracker.service';
import {hasValue} from '@shared/utils/helpers';
import { DndModule } from 'ngx-drag-drop';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-external-drag-and-drop',
    templateUrl: './external-drag-and-drop.component.html',
    styleUrls: ['./external-drag-and-drop.component.scss'],
    standalone: true,
    imports: [DndModule, NgTemplateOutlet]
})
export class ExternalDragAndDropComponent {
  @Input() itemAlignmentClasses = 'flex flex-col space-y-2'

  dragDataValue = [];

  @Input() set dragData(content: any[]) {
    if (!hasValue(content)) {
      this.dragDataValue = [];
      return;
    }

    this.dragDataValue = content.map(c => {
      return {
        data: c,
        effectAllowed: 'copy',
        disable: false,
        handle: false,
      };
    });
  }

  @ContentChild(TemplateRef) templateOutlet!: TemplateRef<any>;

  constructor(public dragTrackerService: DragTrackerService, private cd: ChangeDetectorRef) {
  }

  onDragStart(event: any): void {
    this.dragTrackerService.isDraggingSetValue = true;
  }

  onDragEnd(event: any): void {
    this.dragTrackerService.isDraggingSetValue = false;
  }
}
